module.exports = __webpack_public_path__ + "img/cr3.4d6aa500.png";